// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:51:21

export default {
  "id": "vault-breaker",
  "slug": "vault-breaker",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/76d80d681f864b098bcedcd9af96dc99-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/76d80d681f864b098bcedcd9af96dc99/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Vault Breaker",
      "description": "Can you help our furry thief crack open a vault harbouring a hidden secret? Click when the marker crosses the button and unlock the vault now. ",
      "instructions": "Step into the paws of a cunning little raccoon in a thrilling arcade game that combines quick reflexes with a love for shiny treasures! The objective is simple: watch for a red marker that moves arround the vault door and click precisely when it crosses the gold button. Each level requires you to click a number of times equal to the level you’re on. Every successful click gets you closer to claiming the vault’s riches! Remember, timing is everything!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "2d",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "保险库破坏者",
      "description": "你能帮我们的毛茸茸的小偷打开一个藏有秘密的金库吗？当标记穿过按钮时点击，现在解锁金库。",
      "instructions": "踏入一只狡猾的小浣熊的爪子，体验一场充满刺激的街机游戏，将敏捷的反应与对闪亮宝藏的热爱相结合！目标是简单的：观察移动在保险库门周围的红色标记，并在它穿过金按钮时精确点击。每个关卡都需要你点击的次数等于你所在的关卡级别。每一次成功的点击都会让你更接近获得保险库的财富！记住，时机至关重要！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "2D",
        "技巧"
      ]
    },
    "zh-TW": {
      "title": "金庫破壞者",
      "description": "你能幫我們的毛茸茸盜賊打開藏有隱藏秘密的金庫嗎？當標記穿越按鈕時點擊，現在解鎖金庫。",
      "instructions": "踏上這隻機靈小浣熊的腳步，在刺激的街機遊戲中結合敏捷的反應和對閃耀珍寶的愛好！目標簡單：注意那個在金庫門四周移動的紅色標記，並在它穿越金按鈕時精準點擊。每個等級都需要你點擊的次數與你所在的等級相同。每一次成功的點擊都讓你更接近獲得金庫的財富！記住，時間是關鍵！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1人玩家",
        "2D",
        "技能"
      ]
    },
    "zh-HK": {
      "title": "金庫破壞者",
      "description": "你能幫我們的毛茸茸盜賊打開藏有隱藏秘密的保险庫嗎？當標記穿越按鈕時按鍵，現在解鎖保险庫。",
      "instructions": "踏進一隻狡猾的小浣熊的腳步，在刺激的街機遊戲中結合快速反應和對閃耀珍寶的愛戀！目標簡單：注意移動在金庫門周圍的紅色標記，當它穿過金幣按鈕時精準點擊。每個關卡都需要你點擊的次數等於你所在的關卡級數。每一次成功的點擊都讓你更接近獲得金庫的財寶！記住，時間就是一切！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "2D",
        "技術"
      ]
    },
    "ja": {
      "title": "バウルブレイカー",
      "description": "私たちの毛皮の泥棒が隠された秘密を秘めている金庫を開ける手助けはできますか？マーカーがボタンを通過したらクリックして、今すぐ金庫を解除してください。",
      "instructions": "賢い小さなリスの足に飛び込んで、スリル満点のアーケードゲームで、素早い反応と輝く宝物の愛を組み合わせてみましょう！目標はシンプルです：保管庫の扉を回る赤いマーカーを見つけ、金のボタンを跨ぐ瞬間に正確にクリックしてください。各レベルでは、そのレベルに応じた回数クリックが必要です。成功したクリックで宝庫の富を手に入れるのに近づきます！タイミングがすべてですを思い出してください！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "スキル"
      ]
    },
    "ko": {
      "title": "보스팀브레이커",
      "description": "나는 우리의 귀여운 도적이 숨겨진 비밀을 가진 보관庫를 열 수 있도록 도와줄 수 있나요? 마커가 버튼을 지나갈 때 클릭하세요. 지금 보관庫를 열어주세요.",
      "instructions": "쉽게 빨간 마커가 strongbox 문을 돌아다니는 흥미진진한 아케이드 게임에서 기발한 작은 땡이의 발자국을 걸어보세요! 목표는 간단합니다: 빨간 마커가 금 키보드를 건너는 순간 정확하게 클릭하세요. 각 레벨마다 현재 레벨에 맞는 횟수만큼 클릭해야 합니다. 모든 성공적인 클릭은 strongbox의 귀중한 보물을 얻는 데 가까워지게 합니다! 기억하세요, 시간은 모든 것입니다!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "스킬"
      ]
    },
    "fr": {
      "title": "Brise-Tresor",
      "description": "Pouvez-vous aider notre voleur à fourrure à casser le coffre-fort abritant un secret caché ? Cliquez lorsque le marqueur traverse le bouton et déverrouillez le coffre-fort maintenant.",
      "instructions": "Saisissez les griffes d'un petit renard rusé dans un jeu d'arcade captivant qui combine des réflexes rapides avec une passion pour les trésors brillants ! L'objectif est simple : surveillez un marqueur rouge qui se déplace autour de la porte-fort et cliquez précisément lorsque celui-ci traverse le bouton d'or. Chaque niveau nécessite que vous cliquiez un nombre de fois égal au niveau que vous êtes en train de jouer. Chaque clic réussi vous rapproche de la réclame des richesses du trésor ! N'oubliez pas, le timing est tout !",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "compétence"
      ]
    }
  }
};
